import { Component, OnInit } from '@angular/core';
import { ProfileService } from 'app/core/services/profile.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { MessageService } from 'primeng/api';
import { PaymentsBase } from '../../payments-base';

@Component({
  selector: 'app-payments-mobile',
  templateUrl: './payments-mobile.component.html',
  styleUrls: ['./payments-mobile.component.scss']
})
export class PaymentsMobileComponent extends PaymentsBase implements OnInit {
  constructor(profileService: ProfileService,messageService: MessageService,localizationService: LocalizationService) { 
    super(profileService, messageService, localizationService)
}

  ngOnInit(): void {
    this.initTable()
    this.fillData();
  }

}
